module.exports = __webpack_public_path__ + "static/media/saved_seaplaneport_marker.90f5d892.svg";